import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiFormRow,
  EuiIcon,
  EuiSwitch,
  EuiText,
} from "@inscopix/ideas-eui";
import { useState } from "react";
import { ReactComponent as IconBolt } from "assets/bolt.svg";
import { useDataTableContext } from "../store/DataTableProvider";
import { DataTableStoreState } from "../store/DataTableProvider.types";
import { ModalEditTableBase } from "./ModalEditTableBase";

export type ExecutableTable = Extract<
  DataTableStoreState["tables"][number],
  { kind: "analysis" | "workflow" }
>;

interface ModalEditExecutableTableProps {
  table: ExecutableTable;
  onClose: () => void;
}

export const ModalEditExecutableTable = ({
  table,
  onClose,
}: ModalEditExecutableTableProps) => {
  const updateAnalysisTable = useDataTableContext((s) => s.updateAnalysisTable);
  const updateWorkflowTable = useDataTableContext((s) => s.updateWorkflowTable);
  const updateTable =
    table.kind === "analysis" ? updateAnalysisTable : updateWorkflowTable;

  const [cacheEnabled, setCacheEnabled] = useState(table.cache_enabled);

  return (
    <ModalEditTableBase
      table={table}
      onClose={onClose}
      onSubmit={(fields) =>
        updateTable({ tableId: table.id, ...fields, cacheEnabled })
      }
    >
      <EuiFormRow
        fullWidth
        helpText={
          <EuiText size={"s"}>
            <p>
              {"Reuse previous results when a row is executed with identical inputs, " +
                "parameters, and tool version. Cached results don't count towards compute " +
                "credit or storage usage."}
            </p>
          </EuiText>
        }
      >
        <EuiSwitch
          label={
            <EuiFlexGroup
              responsive={false}
              alignItems="center"
              gutterSize="xs"
            >
              <EuiFlexItem grow={false}>
                <EuiIcon type={IconBolt} size="m" />
              </EuiFlexItem>
              <EuiFlexItem grow={false}>
                <EuiText>
                  {cacheEnabled ? "Caching enabled" : "Caching disabled"}
                </EuiText>
              </EuiFlexItem>
            </EuiFlexGroup>
          }
          checked={cacheEnabled}
          onChange={(e) => setCacheEnabled(e.target.checked)}
        />
      </EuiFormRow>
    </ModalEditTableBase>
  );
};
